export default __webpack_public_path__ + "static/media/03_DAIF_Eco_01_04_end.22c1ec63.jpg";